<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-hobby-group`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23 1.741a1 1 0 01.504.136l9.015 5.26a1 1 0 010 1.727L26 12.666v2.788l17.341 21.283A2 2 0 0141.791 40H6.209a2 2 0 01-1.55-3.263L22 15.453V2.741a1 1 0 011-1zm20 40.26a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38zM23.455 19.998h1.088L37.581 36H10.419l13.036-16z"/></svg>
</template>
<script>

export default {
  name: 'IconHobbyGroup',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
